import { createFormGroupState, updateGroup, validate } from 'ngrx-forms';
import { greaterThan, required } from 'ngrx-forms/validation';

export const PAYMENT_WITHDRAW_FORM_ID = 'Payment_withdraw_form_id';

export interface PaymentWithdrawFormState {
  currency: string | null,
  paymentType: string | null,
  amount: number,
  address: string | null,
}

export const initialPaymentWithdrawFormValue: PaymentWithdrawFormState = {
  currency: null,
  paymentType: null,
  amount: 0,
  address: null,
};

export const initialPaymentWithdrawFormState = createFormGroupState<PaymentWithdrawFormState>(
  PAYMENT_WITHDRAW_FORM_ID,
  initialPaymentWithdrawFormValue,
);

export const validatePaymentWithdrawForm = updateGroup<PaymentWithdrawFormState>({
  currency: validate(required),
  paymentType: validate(required),
  amount: validate(greaterThan(0.1)),
  address: validate(required),
});
